import { useEffect, useRef } from 'react';
import { pushOverlay, dropOverlay } from '../lib/overlayHistory';

let seq = 0;

/**
 * Registers a controlled overlay with the back-button stack.
 *
 * Shared by Dialog, Sheet and AlertDialog so every overlay in the app
 * behaves the same without each caller wiring anything up. Uncontrolled
 * overlays (no `open` prop) are left alone.
 */
export default function useOverlayBack(open, onOpenChange) {
  const id = useRef(null);
  const closeRef = useRef(onOpenChange);
  closeRef.current = onOpenChange;

  useEffect(() => {
    if (typeof open !== 'boolean') return undefined;
    if (open) {
      if (id.current) return undefined;
      id.current = `ov-${++seq}`;
      pushOverlay(id.current, () => closeRef.current?.(false));
    } else if (id.current) {
      const closing = id.current;
      id.current = null;
      dropOverlay(closing);
    }
    return undefined;
  }, [open]);

  // Unmounted while still open (parent navigated away) — clean the entry up.
  useEffect(() => () => {
    if (id.current) {
      dropOverlay(id.current);
      id.current = null;
    }
  }, []);
}
